(() => {
  'use strict';
  if (window.CartaEditorialHome) { window.CartaEditorialHome.refresh(); return; }
  let activeRoot = null;
  let activeCleanup = null;

  function initialize() {
    activeCleanup?.();
    activeCleanup = null;
    activeRoot = document.querySelector('[data-carta-editorial-home]');
    if (!activeRoot) return;
    const root = activeRoot;
    let destroyed = false;
    let frame = 0;
  const body = document.body;
  const scenes = [...root.querySelectorAll('.scroll-scene')];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionButton = document.querySelector('.motion-toggle');
  const progressBar = root.querySelector('.reading-line span');
  const hero = root.querySelector('.hero');
  if (!hero || !motionButton || !progressBar) return;
  let paused = body.classList.contains('motion-paused') || reduced.matches;
  const originals = new Map();
  let ticking = false;
  let geometry = [];
  const clamp = (value, low = 0, high = 1) => Math.min(high, Math.max(low, value));
  const ease = value => value * value * (3 - 2 * value);
  let entryScale = 1;

  // Keep the original complete diary passage available to assistive technology.
  root.querySelectorAll('[data-ink]').forEach(paragraph => {
    const original = paragraph.textContent.trim();
    originals.set(paragraph, original);
    paragraph.textContent = '';
    const transcript = document.createElement('span');
    transcript.className = 'visually-hidden';
    transcript.textContent = original;
    paragraph.appendChild(transcript);
    const words = original.split(/\s+/);
    let offset = 0;
    paragraph._ink = words.map((word, index) => {
      const span = document.createElement('span');
      span.className = 'ink-word';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = word + (index < words.length - 1 ? ' ' : '');
      paragraph.appendChild(span);
      const record = { element: span, start: offset, length: word.length + 1 };
      offset += record.length;
      return record;
    });
    paragraph._inkLength = offset;
  });

  function measure() {
    if (destroyed || !root.isConnected) return;
    const stage = hero.querySelector('.sticky-stage');
    const width = stage.clientWidth;
    const height = stage.clientHeight;
    const phone = width <= 600;
    const left = phone ? 8 : 22;
    const top = phone ? 40 : 36;
    const bottom = phone ? 27 : 13;
    const coverWidth = Math.max(width, height * 16 / 9);
    const coverHeight = coverWidth * 9 / 16;
    entryScale = Math.max(width * (1 - left / 50) / coverWidth, height * (1 - (top + bottom) / 100) / coverHeight);
    hero.style.setProperty('--entry-left', `${left}%`);
    hero.style.setProperty('--entry-top', `${top}%`);
    hero.style.setProperty('--entry-bottom', `${bottom}%`);
    hero.style.setProperty('--cover-width', `${coverWidth}px`);
    hero.style.setProperty('--cover-height', `${coverHeight}px`);
    hero.style.setProperty('--entry-center', `${(top + 100 - bottom) / 2}%`);
    geometry = scenes.map(element => {
      const rect = element.getBoundingClientRect();
      const stage = element.querySelector('.sticky-stage');
      const landscape = element.dataset.scene === 'landscape';
      const stickyOffset = landscape ? parseFloat(getComputedStyle(stage).top) || 0 : 0;
      return { element, landscape, top: rect.top + window.scrollY - stickyOffset, travel: Math.max(1, element.offsetHeight - stage.offsetHeight), ink: [...element.querySelectorAll('[data-ink]')], drifts: [...element.querySelectorAll('[data-drift]')] };
    });
    schedule();
  }

  function draw() {
    ticking = false;
    if (destroyed) return;
    const scroll = window.scrollY;
    geometry.forEach(scene => {
      const value = paused ? 0.55 : clamp((scroll - scene.top) / scene.travel);
      scene.element.style.setProperty('--scene', value.toFixed(4));
      if (scene.landscape) {
        const entered = paused ? 1 : ease(clamp(value / .56));
        scene.element.style.setProperty('--landscape-entered', entered.toFixed(4));
      }
      if (scene.element === hero) {
        const entered = paused ? 1 : ease(clamp(value / .57));
        hero.style.setProperty('--entered', entered.toFixed(4));
        hero.style.setProperty('--film-scale', (entryScale + (1.045 - entryScale) * entered).toFixed(4));
        hero.style.setProperty('--intro-opacity', (paused ? 0 : 1 - ease(clamp(value / .24))).toFixed(4));
        hero.style.setProperty('--frame-opacity', (paused ? 0 : 1 - ease(clamp(value / .36))).toFixed(4));
        hero.style.setProperty('--arrival-opacity', (paused ? 1 : ease(clamp((value - .60) / .07))).toFixed(4));
      }
      scene.drifts.forEach(photo => photo.style.setProperty('--drift', `${(value - .5) * Number(photo.dataset.drift)}px`));
      scene.ink.forEach(paragraph => {
        const start = Number(paragraph.dataset.start || 0);
        const end = Number(paragraph.dataset.end || 1);
        const amount = paused ? 1 : clamp((value - start) / (end - start));
        const cursor = amount * paragraph._inkLength;
        paragraph._ink.forEach(word => {
          const revealed = clamp((cursor - word.start) / word.length);
          word.element.style.clipPath = `inset(0 ${(1 - revealed) * 100}% 0 0)`;
        });
      });
    });
    progressBar.style.transform = `scaleX(${clamp(scroll / Math.max(1, document.documentElement.scrollHeight - innerHeight))})`;
  }
  function schedule() { if (!destroyed && !ticking) { ticking = true; frame = requestAnimationFrame(draw); } }

  function mountFilm(film) {
    if (paused || film.querySelector('iframe')) return;
    const iframe = document.createElement('iframe');
    iframe.src = film.dataset.film;
    iframe.title = film.getAttribute('aria-label');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    film.querySelector('.film-mount').appendChild(iframe);
  }
  const filmObserver = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) mountFilm(entry.target);
    else entry.target.querySelector('iframe')?.remove();
  }), { rootMargin: '250px 0px' });
  root.querySelectorAll('.film').forEach(film => filmObserver.observe(film));

  function setMotion(value) {
    const anchor = scenes.find(scene => { const rect = scene.getBoundingClientRect(); return rect.top <= 90 && rect.bottom > 90; });
    const oldTop = anchor?.getBoundingClientRect().top;
    paused = value;
    body.classList.toggle('motion-paused', paused);
    motionButton.setAttribute('aria-pressed', String(paused));
    motionButton.setAttribute('aria-label', paused ? 'Resume motion' : 'Pause motion');
    motionButton.querySelector('.motion-label').textContent = paused ? 'Resume motion' : 'Pause motion';
    motionButton.querySelector('.motion-symbol').textContent = paused ? '▷' : 'Ⅱ';
    root.querySelectorAll('.film').forEach(film => {
      if (paused) film.querySelector('iframe')?.remove();
      else { const rect = film.getBoundingClientRect(); if (rect.bottom > -250 && rect.top < innerHeight + 250) mountFilm(film); }
    });
    if (anchor && oldTop !== undefined) {
      const newTop = anchor.getBoundingClientRect().top;
      window.scrollBy({ top: newTop - oldTop, behavior: 'instant' });
    }
    measure();
  }
  const toggleMotion = () => setMotion(!paused);
  const reducedChanged = event => setMotion(event.matches);
  motionButton.addEventListener('click', toggleMotion);
  reduced.addEventListener('change', reducedChanged);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('load', measure);
  document.fonts.ready.then(() => { if (!destroyed) measure(); });
  activeCleanup = () => {
    destroyed = true;
    cancelAnimationFrame(frame);
    filmObserver.disconnect();
    root.querySelectorAll('.film iframe').forEach(iframe => iframe.remove());
    motionButton.removeEventListener('click', toggleMotion);
    reduced.removeEventListener('change', reducedChanged);
    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', measure);
    window.removeEventListener('load', measure);
    originals.forEach((original, paragraph) => {
      paragraph.textContent = original;
      delete paragraph._ink;
      delete paragraph._inkLength;
    });
  };
  setMotion(paused);
  }

  window.CartaEditorialHome = { refresh: initialize };
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches?.('[data-carta-editorial-home]') || event.target.querySelector?.('[data-carta-editorial-home]')) initialize();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (activeRoot && event.target.contains(activeRoot)) {
      activeCleanup?.();
      activeCleanup = null;
      activeRoot = null;
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
